<template>
  <svg
  :id="uniqueId"
  :class="classnames"
  :fill="`currentColor`"
  :height="getHeight"
  :viewBox="`0 0 25 25`"
  :width="getWidth"
  >
    <g transform="translate(-613.000000, -235.000000)">
      <g transform="translate(613.000000, 235.000000)">
        <path d="M23.953475,9.06372656 C21.3769083,0.473086458 17.6542453,-1.53082344 9.06360521,1.046525 C0.473745833,3.62309167 -1.53094531,7.34575469 1.04640313,15.9363948 C3.62375156,24.5262542 7.34641458,26.5309453 15.9362734,23.9535969 C24.5269135,21.3762484 26.5308234,17.6535854 23.953475,9.06372656 L23.953475,9.06372656 Z M19.6089365,14.640299 L17.9894021,15.1824875 L18.5503406,16.8590531 C18.7776849,17.5371792 18.4120594,18.2715552 17.7331516,18.4988995 C17.5854953,18.5488995 17.4354948,18.5699932 17.2886198,18.566087 C16.7589312,18.5520245 16.270649,18.2129615 16.0933052,17.6817104 L15.5315854,16.0059266 L12.1917354,17.1246786 L12.752674,18.8004625 C12.9800182,19.4793703 12.6143927,20.2137464 11.9354849,20.4410906 C11.7878286,20.4903094 11.6378281,20.5114031 11.4909531,20.5074969 C10.9612646,20.4942156 10.4729823,20.1543714 10.2956385,19.6239016 L9.73391875,17.9473359 L8.11438437,18.4903057 C7.96672812,18.5395245 7.81594635,18.5606182 7.66907135,18.556712 C7.14016406,18.5434307 6.65188177,18.2035865 6.47375677,17.6723354 C6.2464125,16.9942094 6.61203802,16.2598333 7.29094531,16.0324891 L8.91126094,15.4895193 L7.8339151,12.2746698 L6.21438125,12.8176396 C6.06672448,12.8668583 5.91672448,12.8879521 5.76906771,12.8840458 C5.24016042,12.8707646 4.75187865,12.5309203 4.57375313,11.9996693 C4.34640885,11.3215432 4.71281615,10.5871667 5.39094219,10.3598224 L7.01125729,9.81685313 L6.44953802,8.14106875 C6.22219375,7.46216094 6.58781927,6.7277849 7.26672656,6.50122188 C7.94563438,6.2738776 8.68001042,6.63950365 8.90735469,7.31841094 L9.46829323,8.99419531 L12.808924,7.87544323 L12.2472042,6.19965885 C12.0198604,5.52075156 12.3862672,4.786375 13.0643932,4.55903125 C13.743301,4.33168698 14.4776771,4.69809375 14.7050214,5.37621979 L15.2659599,7.05278542 L16.886275,6.50981563 C17.5651828,6.28247135 18.2987776,6.64887865 18.5261219,7.32700469 C18.7534661,8.00591198 18.3878401,8.74028854 17.7089328,8.96763281 L16.089399,9.50982083 L17.165963,12.7254516 L18.7862786,12.1824823 C19.4644047,11.9559193 20.1987812,12.3215448 20.426125,12.9996708 C20.6534693,13.6785786 20.2878438,14.4129547 19.6089365,14.640299 Z M10.2914979,11.4517776 L11.368062,14.6666271 L14.7086932,13.547875 L13.6321286,10.3330255 L10.2914979,11.4517776 Z" />
      </g>
    </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-slack'

  export default {
    name: 'SvgIconSlack',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '25',
        type: String
      },
      width: {
        default: '25',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconSlack.vue